import React, { useRef, useState } from 'react'
import { Ratio } from 'react-bootstrap'
import styles from './index.module.css'
import { serSetTabdata } from '../../axios';
import Alertwin from '../Alertwin';
import { useSelector } from 'react-redux';
import langList from '../../utils/languagelist.json'

export default function Btnsave() {

  const [popoverTitle, setPopoverTitle] = useState({});
  const target = useRef(null);

  let {jy,un,...tabdata}=useSelector((state)=>state.tabplate);
  const {sec}=useSelector((state)=>state.timerslice);
  tabdata={...tabdata,sec}

  const {expires}=useSelector((state)=>state.logininfo);
  const {usern}=useSelector((state)=>state.logininfo);
  const {lg}=useSelector((state)=>state.language);

  // 功能键背景色
  const {bm}=useSelector((state)=>state.colorplate);

  if (Object.keys(popoverTitle).length !== 0) {
    setTimeout(() => {
      setPopoverTitle({});
    }, 5000);
  }

  const saveBtnClick = ()=>{
    if (Object.keys(popoverTitle).length !== 0)return;
    if(expires<Date.now()){
      setPopoverTitle({mark:1,message:`${langList.btnsave1[lg]}`})
      return;
    }
    serSetTabdata({name:usern,tabdata})
    .then(res =>{
      const mark=res.code===24?3:2
      setPopoverTitle({mark:mark,message:`${langList.btnsave2[lg]}`})
    })
    .catch(err =>{
      const mark=err.code===100?1:2;
      let message='';
      switch(err.code){
        case 100:
          message=`${langList.buttbar7[lg]}`
          break;
        case 401:
          message=`${langList.btnsave1[lg]}`
          break;
        default:
          message=err.message
          break;
      }
      setPopoverTitle({mark:mark,message:message});
    });
  };

  return (
    <>
      <Ratio aspectRatio={"1x1"}>
        <div ref={target} onClick={saveBtnClick}>
            <div className={styles.b_s_adiv} style={{backgroundColor:bm}}>
              <img src='./pic/save.svg' alt='' className={styles.b_s_img}/>
            </div>
        </div>
      </Ratio>
      {/* mark=1是杯子图标；2是圆形包裹!号图标；3是√图标 */}
      <Alertwin nu={{target:target,place:"top",title:popoverTitle.message,mark:popoverTitle.mark}} />
  </>
  )
}
